/*!

 * Copyright 2012, T&Y Design
 
*/

 
// Variables
var inMotion = 0;

$(function() {
    // initialize scrollable
    $(".scrollable").scrollable({
    speed:400,
    easing:"swing",
    circular:true
    });
});
    


$(document).ready(function() {
    
    $('.menu li').hover(
        function () {
            //show its submenu
            $('ul', this).stop().slideDown(100);
 
        }, 
        function () {
            //hide its submenu
            $('ul', this).stop().slideUp(100);          
        }
    );
    
    $('.slider-nav-left').hover(
        function() {
        $('.slider-nav-left').animate({
        marginLeft: "-45px",
        paddingRight: "5px"
        }, 50, "swing", function() {
        // Animation complete.
        });
        },
        function() {
        $('.slider-nav-left').animate({
        marginLeft: "-40px",
        paddingRight: "0px"
        }, 50, "swing", function() {
        // Animation complete.
        });
        }
    );
    
    $('.slider-nav-right').hover(
        function() {
        $('.slider-nav-right').animate({
        marginRight: "-45px",
        paddingLeft: "5px"
        }, 50, "swing", function() {
        // Animation complete.
        });
        },
        function() {
        $('.slider-nav-right').animate({
        marginRight: "-40px",
        paddingLeft: "0px"
        }, 50, "swing", function() {
        // Animation complete.
        });
        }
    );

});